import Notes from 'midi/Notes.js';
export const getRows = (octave) => {
        let rows = [];
    let note = Notes.fromString('C2').addTranspose(
        octave * 16).toString();
    for (let i=0; i < 4; i++) {
        let row = [];
        for (let j=0; j < 4; j++) {
            row.push(note);
            let tranpose = Notes.fromString(note).getTranspose();
            note = Notes.fromString(note).addTranspose(1).toString();
        }
        rows.push(row);
    }
    
    let pads = rows.reverse();
    return pads;
};
